import { PropsWithChildren, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { checkAdminSession, checkCustomerSession } from "@/services/session";

function GuardSpinner() {
  return (
    <div className="p-6 w-full flex items-center justify-center">
      <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export function RequireAdmin({ children }: PropsWithChildren) {
  const [allowed, setAllowed] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let alive = true;
    (async () => {
      const ok = await checkAdminSession();
      if (!alive) return;
      if (ok) setAllowed(true);
      else navigate("/", { replace: true, state: { from: location.pathname } });
    })();
    return () => {
      alive = false;
    };
  }, [navigate, location.pathname]);

  if (allowed !== true) return <GuardSpinner />;
  return children as any;
}

export function RequireCustomer({ children }: PropsWithChildren) {
  const [allowed, setAllowed] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let alive = true;
    (async () => {
      const ok = await checkCustomerSession();
      if (!alive) return;
      if (ok) setAllowed(true);
      else navigate("/", { replace: true, state: { from: location.pathname } });
    })();
    return () => {
      alive = false;
    };
  }, [navigate, location.pathname]);

  if (allowed !== true) return <GuardSpinner />;
  return children as any;
}
